import React from 'react';
import '../../assets/css/loader.css';

function Loader(props) {
    return (
        <div style={{ "width": "100vw", "height": "100vh", "backgroundColor": "#FFF9FF" }}>
            <div className="lds-ring" style={{ margin: "auto", position: "absolute", top: "0", left: "0", bottom: "0", right: "0" }}><div></div></div>
        </div>
    );
}

export default Loader;